import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import required modules modules
import { FreeMode, Thumbs } from 'swiper/modules';
import SwiperNavButtons from './SwiperNavButtons';
import fetchThumbnail from '../../Util/fetchThumbnail';
import VideoPlayer from '../Newsfeed/VideoPlayer';
import LightBox from '../Lightbox/LightBox';
import '../../Util/i18n';
const isVideoSlide = (slide) => slide.type === 'video';
const SwiperCarousel = ({ images, showThumbnails, videoUrl, videoSource }) => {
    var _a;
    const { t } = useTranslation();
    const [mainSwiper, setMainSwiper] = useState(null);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [slides, setSlides] = useState([]);
    const [isLightBoxOpen, setLightBoxOpen] = useState(false);
    const [lightBoxIndex, setLightBoxIndex] = useState(0);
    const [slidesForLightBox, setSlidesForLightBox] = useState([]);
    const [videoThumbnail, setVideoThumbnail] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const openLightBox = (index) => {
        setLightBoxIndex(index);
        setLightBoxOpen(true);
    };
    useEffect(() => {
        const newSlides = [];
        if (videoUrl && videoSource) {
            newSlides.push({ videoSource, videoUrl, type: 'video' });
            fetchThumbnail(videoUrl, videoSource)
                .then((thumbnail) => {
                setVideoThumbnail(thumbnail);
            })
                .catch(console.error);
        }
        newSlides.push(...images);
        setSlides(newSlides);
        setSlidesForLightBox([
            {
                src: videoUrl,
                type: 'video',
                provider: videoSource,
                width: 1280,
                alt: 'Video',
                height: 720
            },
            ...images
        ]);
    }, [images, videoUrl, videoSource]);
    return (React.createElement("div", { className: "flex flex-col gap-2" },
        React.createElement(Swiper, { style: {
                '--swiper-navigation-color': '#fff',
                '--swiper-pagination-color': '#fff',
            }, onSwiper: setMainSwiper, loop: slides.length > 1, onSlideChange: (swiper) => setActiveIndex(swiper.realIndex), spaceBetween: 10, 
            // Fix: Explicitly check for !destroyed state to prevent runtime/TS errors
            thumbs: { swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }, modules: [FreeMode, Thumbs], className: "rounded-lg" },
            slides.map((slide, idx) => (React.createElement(SwiperSlide, { className: "aspect-video", key: slide.type === 'image' ? slide.alt : idx }, isVideoSlide(slide) ? (React.createElement(VideoPlayer, { videoUrl: slide.videoUrl, videoSource: slide.videoSource })) : (React.createElement("img", { className: "aspect-video object-cover w-full h-full block rounded-lg", src: slide.src, alt: slide.alt ? slide.alt : "Image" }))))),
            slides.length > 1 && React.createElement(SwiperNavButtons, null),
            slides.length && ((_a = slides[activeIndex]) === null || _a === void 0 ? void 0 : _a.type) !== 'video' &&
                React.createElement("div", { className: "absolute z-1 bottom-0 h-16 w-full bg-gradient-to-t from-black/80 to-transparent rounded-b-lg" },
                    React.createElement("button", { type: "button", onClick: () => openLightBox(activeIndex), className: "absolute bottom-2 right-2 text-white inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-blue-600 transition-all duration-100" },
                        React.createElement("span", { className: "material-symbols-outlined" }, "pan_zoom")))),
        showThumbnails &&
            React.createElement(Swiper, { onSwiper: setThumbsSwiper, loop: slides.length > 1, spaceBetween: 10, slidesPerView: 4, freeMode: true, watchSlidesProgress: true, modules: [FreeMode, Thumbs], className: "mySwiper" }, slides.map((slide, idx) => (React.createElement(SwiperSlide, { className: "aspect-video", key: slide.type === 'image' ? slide.alt : idx },
                React.createElement("button", { type: "button", onClick: () => mainSwiper === null || mainSwiper === void 0 ? void 0 : mainSwiper.slideToLoop(idx), "aria-label": t('proposalDetail.ariaLabel').replace('%initial%', (idx + 1).toString()).replace('%total%', slides.length.toString()), className: "aspect-video border-2 cursor-pointer transition-opacity duration-200 rounded-lg overflow-hidden" },
                    React.createElement("img", { className: "aspect-video object-cover w-full h-full block", src: slide.type === 'video' ? videoThumbnail : slide.src, alt: slide.type === 'image' ? slide.alt : "video thumbnail" })))))),
        slides.length > 0 &&
            React.createElement(LightBox, { type: "lightbox", images: slidesForLightBox, isOpen: isLightBoxOpen, initialIdx: lightBoxIndex, closeLightBox: () => {
                    return setLightBoxOpen(false);
                } })));
};
export default SwiperCarousel;
